import $ from "cash-dom";
import { clamp } from "Utilities";

export default (function () {
    /**
     * Initialize Draggable instances
     */
    $(document).ready(function () {
        var selector = ".draggable";
        var $selector = $(selector);

        if ($selector.length) {
            function lockScroll() {
                document.documentElement.style.cssText += "position: absolute; inset: 0; overflow: hidden;";
            }
            function unlockScroll() {
                document.documentElement.style.cssText -= "position: absolute; inset: 0; overflow: hidden;";
            }
            function moveHandle(_e) {
                _e.preventDefault();

                var parent = $(_e.target).parents(selector);
                var handle = parent.find("button");
                var x;

                x = _e.type == "mousemove" ? _e.clientX : _e.touches[0].clientX;
                x = x - parent[0].getBoundingClientRect().left;
                x = (x / parent[0].offsetWidth) * 100;
                x = clamp(x, 0, 100);

                handle[0].style.left = `${x}%`;
                handle[0].previousElementSibling.style.clipPath = `inset(0 0 0 ${x}%)`;
            }

            function moveHandleKeyboard(_e) {
                _e.preventDefault();
                var parent = $(_e.target).parents(selector);
                var handle = parent.find("button");
                var x;
                var inc = 5;

                x = parseFloat(handle[0].style.left);

                switch (_e.which) {
                    // Left
                    case 37:
                        x -= inc;
                        break;
                    // Right
                    case 39:
                        x += inc;
                        break;
                }

                x = clamp(x, 0, 100);

                handle[0].style.left = `${x}%`;
                handle[0].previousElementSibling.style.clipPath = `inset(0 0 0 ${x}%)`;
            }

            function resetHandle() {
                $selector.find("button").each(function () {
                    var defaultPos = $(this).attr("data-default-position") || 50;
                    $(this)[0].style.left = `${defaultPos}%`;
                    $(this)[0].previousElementSibling.style.clipPath = `inset(0 0 0 ${defaultPos}%)`;
                });
            }

            resetHandle();

            $selector.find("button").on("mousedown", function () {
                lockScroll();
                window.addEventListener("mousemove", moveHandle);
            });

            window.addEventListener("mouseup", function () {
                unlockScroll();
                window.removeEventListener("mousemove", moveHandle);
            });

            $selector.find("button").on(
                "touchstart",
                function () {
                    lockScroll();
                    window.addEventListener("touchmove", moveHandle);
                },
                { passive: true }
            );

            window.addEventListener(
                "touchend",
                function () {
                    unlockScroll();
                    window.removeEventListener("touchmove", moveHandle);
                },
                { passive: true }
            );

            window.addEventListener("dblclick", resetHandle);

            $selector.on("keyup", ".tab-focus", moveHandleKeyboard);
        }
    });
})();
